<ion-row class="border-light-2">
  <ion-col [size]="mobile ? 4 : 3" class="padding-s d-flex align-center text-center" [class.flex-center]="gradeType !== type.ABC">
    <span
      id="grade-name"
      [class.padding-left]="type.ABC === gradeType"
      [class.margin-left-3xl]="type.ABC === gradeType && !mobile"
      [class.margin-left-m]="type.ABC === gradeType && mobile"
      >
      {{ grade.name | titlecase }}
    </span>
  </ion-col>
  @if (currentStep !== 2) {
    <ion-col [size]="mobile ? 6 : 4">
      <app-grade-times-received
        class="d-flex padding-l flex-center flex-column"
        [grade]="grade"
        [valid]="validGrades"
        (selectedTimesAchieved)="selectedTimesAchieved($event)"
      ></app-grade-times-received>
    </ion-col>
  }
  @if (!mobile || currentStep === 2) {
    <ion-col [size]="mobile ? 6 : 4" class="padding-l text-center">
      <span
        ><app-grade-range
        class="d-flex align-center flex-column"
        [grade]="grade"
        [gradeList]="gradeList"
        [valid]="validGrades"
      ></app-grade-range>
    </span>
  </ion-col>
}
<ion-col [size]="mobile ? 2 : 1" class="d-flex align-center" id="delete-grade">
  @if ((!mobile || currentStep === 2) && gradeList.length > 3) {
    <span class="d-flex flex-center">
      <ion-button fill="clear" (click)="deleteRow()" size="small" aria-label="delete grade">
        <ion-icon class="font-l" color="tertiary" name="trash" slot="icon-only"></ion-icon>
      </ion-button>
    </span>
  }
</ion-col>
</ion-row>
